
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"14","height":"14"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#8F7A61","d":"M2.05 10.44C.61 10.38.15 9.91.15 8.55V3.42c0-1.26.53-1.79 1.77-1.8 2.63-.01 5.27 0 7.9 0 1.57 0 1.97.36 2.12 1.89 1.59.21 1.91.57 1.91 2.19v4.89c0 1.26-.53 1.79-1.77 1.8-2.63.01-5.27 0-7.9 0-1.57 0-1.98-.37-2.13-1.95zm8.84-6.87c.08-.61-.01-.99-.68-.98-2.8.01-5.6-.01-8.4.03-.23 0-.65.38-.65.58-.05 1.87-.05 3.75 0 5.63 0 .21.37.59.57.59 2.85.04 5.71.04 8.56 0 .21 0 .6-.35.6-.55.05-1.43.03-2.86.03-4.35H1.61c.02-.35.03-.63.04-.95h9.24zm1.98 2.93c-.38.02-.66.03-.98.04v1.84c0 1.59-.45 2.04-2.02 2.04H3.12c-.09.58-.02.98.65.98 2.8-.01 5.6-.01 8.4 0 .46 0 .71-.17.71-.67-.01-1.37-.01-2.75-.01-4.23zm-.96-1h.91c.05-.9-.02-.97-.91-.87v.87z"}})])
          )
        }
      }
    